import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';

export default function HeroSection() {
  return (
    <section className="relative h-[580px] md:h-[680px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20with%20soft%20coral%20and%20warm%20cream%20gradient%20background%2C%20subtle%20watercolor%20texture%2C%20delicate%20floating%20ink%20brush%20strokes%20in%20warm%20terracotta%20tones%2C%20minimalist%20elegant%20composition%2C%20dreamy%20atmospheric%20mood%2C%20soft%20diffused%20lighting%2C%20no%20text&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
        alt="哈哈漫画网 - 韩国漫画免费在线阅读平台"
        title="哈哈漫画网 - 韩国漫画免费在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <Navbar />

      <div className="relative z-10 w-full h-full flex items-end pb-12 md:pb-16 px-4 md:px-6">
        <div className="w-full max-w-2xl">
          <span className="inline-block px-4 py-1.5 mb-4 md:mb-6 rounded-full border border-background-50/40 text-background-50 text-xs md:text-sm font-medium whitespace-nowrap">
            每日更新 · 高清画质
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-3 md:mb-4">
            韩国漫画
            <span className="block text-primary-300">免费在线观看</span>
          </h1>
          <p className="text-sm md:text-base text-background-50/80 mb-6 md:mb-8 max-w-lg leading-relaxed">
            哈哈漫画网提供高清韩漫全集下拉式阅读，海量漫画资源每日更新，随时随地畅享优质阅读体验
          </p>
          <div className="flex items-center gap-3 flex-wrap">
            <Link
              to="/category/lianai"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              开始阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-50/30 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
          <div className="flex items-center gap-6 mt-6 md:mt-8 text-background-50/70 text-xs md:text-sm">
            <div className="flex items-center gap-1.5">
              <span className="font-bold text-background-50 text-base md:text-lg">12+</span>
              <span>漫画分类</span>
            </div>
            <div className="w-px h-4 bg-background-50/30"></div>
            <div className="flex items-center gap-1.5">
              <span className="font-bold text-background-50 text-base md:text-lg">1000+</span>
              <span>漫画资源</span>
            </div>
            <div className="w-px h-4 bg-background-50/30"></div>
            <div className="flex items-center gap-1.5">
              <span className="font-bold text-background-50 text-base md:text-lg">50w+</span>
              <span>活跃读者</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}